import { environment } from '../../environments/environment';

// use for production server
export const base = environment.api_base;

// use for testing server
// export const base = environment.production ? 'https://exams-test.dm.cit.tum.de/api' : 'http://localhost:8000';
